module.exports = __webpack_public_path__ + "static/media/caex_sustentable.6b292518.png";